/* eslint-disable no-underscore-dangle */
import { InMemoryCache } from "@apollo/client";
import introspectionResult from "graphql-api/introspection";
import { typePolicies } from "./typePolicies";

// Create cache with type-safe configuration
export function createCache() {
  return new InMemoryCache({
    typePolicies,
    possibleTypes: introspectionResult.possibleTypes,
    resultCaching: true,
    // Normalize cache IDs consistently
    dataIdFromObject: (object: unknown) => {
      if (
        object &&
        typeof object === "object" &&
        "__typename" in object &&
        "id" in object &&
        object.__typename &&
        object.id
      ) {
        return `${object.__typename}:${object.id}`;
      }
      return undefined;
    }
  });
}
